/**
 * Take-away "DOWNLOAD PDF" button on single-post.
 *
 * Triggers the browser's native print dialog. The print stylesheet
 * (in single-post.scss) hides nav, sidebar, byline-share, related,
 * newsletter — leaving prose + figures only. The user picks
 * "Save as PDF" as the destination and gets a clean field-note
 * PDF without us shipping a server-side PDF renderer.
 */
const init = () => {
    document.querySelectorAll('[data-tx-print-post]').forEach((btn) => {
        btn.addEventListener('click', () => window.print());
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
